import React from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";

import { PrinterSetting as SharedPrinterSetting } from "@components/Common/PrinterSetting";

import { store as kioskStore, setIsConfigurationPrinterClicked } from "./store";
import { buildKioskPrinterSettingConfig } from "./printerSettingConfig";

type PrinterRowData = Record<string, unknown> & { shopId?: string };

type PrinterSettingSharedProps = {
    rowData: PrinterRowData;
    oneShop: boolean;
    setDataIsUpdated?: (value: boolean | number) => void;
};

export default function PrinterSettingShared({
    rowData,
    oneShop,
    setDataIsUpdated,
}: PrinterSettingSharedProps) {
    const { t } = useTranslation();
    const { isConfigurationPrinterClicked } = useSnapshot(kioskStore);

    const config = React.useMemo(() => buildKioskPrinterSettingConfig(t), [t]);

    return (
        <SharedPrinterSetting
            isOpen={isConfigurationPrinterClicked}
            onClose={() => setIsConfigurationPrinterClicked(false)}
            rowData={rowData}
            oneShop={oneShop}
            config={config}
            onSaved={() => setDataIsUpdated?.(true)}
        />
    );
}
